import React, { useState } from 'react'
import './Select_payment.css'
import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router-dom';
import { IDS } from '../../../utils/IDS';
import { formatAmount } from '../../../utils/common';

const Select_payment = ({ orderAddress, setPaymentValue, paymentValue, walletAmount }) => {

    const navigate = useNavigate();


    const formattedAddress = [
        orderAddress?.building,
        orderAddress?.floor,
        orderAddress?.apartment,
        orderAddress?.street,
        orderAddress?.direction,
        orderAddress?.Users_Address_Detail?.City?.name,
        orderAddress?.Users_Address_Detail?.State?.name,
        orderAddress?.Users_Address_Detail?.Country?.name,
        orderAddress?.Users_Address_Detail?.Pincode?.name,
    ].filter(Boolean).join(", ");
    return (
        <>
            <section className='Select_payment_sec'>


                {/* <div className='paybox'>
                    <div className='addflex'>
                        <div className='icondiv'>
                            <img className='loc-img' src={process.env.PUBLIC_URL + '/assets/images/icons/location.png'} alt="location" />
                        </div>
                        <div className='contdiv'>
                            <p className='apartp'><img className='aprticn' src={process.env.PUBLIC_URL + '/assets/images/icons/Apartment.png'} />{orderAddress?.Address_Type?.name || " "}</p>
                            <p className='address'>{formattedAddress || ""}</p>
                        </div>
                    </div>
                </div> */}

                <div className='paybox'>
                    <div className='addflex justify-content-between'>
                        <div className='contdiv'>
                            <h6 className='boxtitle'>Pay Online</h6>
                            <p className='address'>
                                <img className='delimg'
                                    src={process.env.PUBLIC_URL + '/assets/images/icons/pay.png'} />
                                Pay securely using UPI / Cards / Wallets
                            </p>
                        </div>

                        <div className='icondiv'>
                            <Form.Check
                                type="radio"
                                name="paymentOption"
                                value={IDS.Payment_Methods.Online}
                                // value="online"
                                onChange={(e) => setPaymentValue(e.target.value)}
                                checked={paymentValue == IDS.Payment_Methods.Online}
                            />
                        </div>
                    </div>
                </div>

                {/* COD */}
                <div className='paybox'>
                    <div className='addflex justify-content-between'>
                        <div className='contdiv'>
                            <h6 className='boxtitle'>Pay On Check In</h6>
                            <p className='address'>
                                <img className='delimg'
                                    src={process.env.PUBLIC_URL + '/assets/images/icons/pay.png'} />
                                Cash / UPI Payment at Check-in
                            </p>
                        </div>

                        <div className='icondiv'>
                            <Form.Check
                                type="radio"
                                name="paymentOption"
                                value={IDS.Payment_Methods.Cash}                                // value="cod"
                                onChange={(e) => setPaymentValue(e.target.value)}
                                checked={paymentValue == IDS.Payment_Methods.Cash}
                            />
                        </div>
                    </div>
                </div>
                <div className='paybox'>
                    <div className='addflex justify-content-between'>
                        <div className='contdiv'>
                            <h6 className='boxtitle'>Pay With Wallet</h6>
                            <p className='address'>
                                <img className='delimg'
                                    src={process.env.PUBLIC_URL + '/assets/images/icons/pay.png'} />
                                Wallet Amount :  {formatAmount(walletAmount)}                            </p>
                        </div>

                        <div className='icondiv'>
                            <Form.Check
                                type="radio"
                                name="paymentOption"
                                value={IDS.Payment_Methods.Wallete}                                // value="cod"
                                onChange={(e) => setPaymentValue(e.target.value)}
                                checked={paymentValue == IDS.Payment_Methods.Wallete}
                            />
                        </div>
                    </div>
                </div>

                {/*

                <div className='paybox'>
                    <h6 className='boxtitle'>Recommended for You</h6>
                    <p className='payp'>Pay with UPI</p>
                    <div className='row'>
                        <div className='col-md-3 col-4 '>
                            <Form.Check
                                type="radio"
                                id="radio-gpay"
                                name="paymentOption"
                                value="gpay"
                                onChange={(e) => setPaymentValue(e.target.value)}
                                checked={paymentValue === "gpay"}
                                label={
                                    <span>
                                        <img className='payimg' src={process.env.PUBLIC_URL + '/assets/images/icons/gpay.png'} alt="option" />
                                    </span>
                                }
                            />
                        </div>
                        <div className='col-md-3 col-4  '>
                            <Form.Check
                                type="radio"
                                id="radio-phonepe"
                                name="paymentOption"
                                value="phonepe"
                                onChange={(e) => setPaymentValue(e.target.value)}
                                checked={paymentValue === "phonepe"}
                                label={
                                    <span>
                                        <img className='payimg' src={process.env.PUBLIC_URL + '/assets/images/icons/phonepe.png'} alt="option" />
                                    </span>
                                }
                            />
                        </div>
                        <div className='col-md-3 col-4  '>
                            <Form.Check
                                type="radio"
                                id="radio-paytm"
                                name="paymentOption"
                                value="paytm"
                                onChange={(e) => setPaymentValue(e.target.value)}
                                checked={paymentValue === "paytm"}
                                label={
                                    <span>
                                        <img className='payimg' src={process.env.PUBLIC_URL + '/assets/images/icons/paytm.png'} alt="option" />
                                    </span>
                                }
                            />
                        </div>
                    </div>
                </div>

                <div className='paybox'>
                    <div className='addflex justify-content-between'>
                        <div className='contdiv'>
                            <h6 className='boxtitle'>Pay on Delivery</h6>
                            <p className='address'><img className='delimg' src={process.env.PUBLIC_URL + '/assets/images/icons/pay.png'} />Pay on Delivery (Cash / UPI)</p>
                        </div>
                        <div className='icondiv'>
                            <Form.Check
                                type="radio"
                                name="paymentOption"
                                value="cod"
                                onChange={(e) => setPaymentValue(e.target.value)}
                                checked={paymentValue === "cod"}
                            />

                        </div>
                    </div>
                </div>

                <div className='paybox'>
                    <div className='addflex justify-content-between'>
                        <div className='contdiv'>
                            <h6 className='boxtitle'>Credit & Debit Cards<span className='savep'>(Save & Pay via Cards)</span></h6>
                            <p className='address'><img className='delimg' src={process.env.PUBLIC_URL + '/assets/images/icons/credit.png'} />Add New Card</p>
                        </div>

                    </div>
                </div>

                <div className='paybox'>
                    <div className='addflex justify-content-between'>
                        <div className='contdiv'>
                            <h6 className='boxtitle'>Wallet</h6>
                            <p className='address'><img className='delimg' src={process.env.PUBLIC_URL + '/assets/images/icons/wallet.png'} />Balance : ₹ 0</p>
                        </div>
                        <div className='icondiv'>
                            <button className='addwalbtn' onClick={() => { navigate('/add-wallet') }}>Add</button>
                        </div>
                    </div>
                </div> */}
            </section>
        </>
    )
}

export default Select_payment